import ProductPageMainComp from "./ProductPageMainComp";

export default ProductPageMainComp;
